import { render, staticRenderFns } from "./FooterLink.vue?vue&type=template&id=55a19a14&scoped=true&"
import script from "./FooterLink.vue?vue&type=script&lang=ts&"
export * from "./FooterLink.vue?vue&type=script&lang=ts&"
import style0 from "./FooterLink.vue?vue&type=style&index=0&id=55a19a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a19a14",
  null
  
)

export default component.exports